module.exports = __webpack_public_path__ + "img/ctrl-c-stub-down-1.ea43f87e.svg";